module.exports = __webpack_public_path__ + "img/H2.c4eca3c3.png";